import { InfoOutlined } from '@mui/icons-material';
import { EventStatusEnum } from 'domain/event/EventStatusEnum';
import { TypeEventCodeEnum } from 'domain/event/TypeEventCodeEnum';
import { Title } from 'primary/Components/Title/Title';
import { MatchEditLigue } from 'primary/events/components/matchs/edit/MatchEditLigue';
import { MatchEditLigueBR } from 'primary/events/components/matchs/edit/MatchEditLigueBR';
import { MatchEditTournament } from 'primary/events/components/matchs/edit/MatchEditTournament';
import { EventViewPageContext } from 'primary/events/item/EventViewPage';
import { useContextDependency } from 'primary/hooks/useContextDependency';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';
import { useOutletContext } from 'react-router-dom';

const ComponentByTypeEvent = {
  [TypeEventCodeEnum.LIGUE]: MatchEditLigue,
  [TypeEventCodeEnum.LIG_BR]: MatchEditLigueBR,
  [TypeEventCodeEnum.TOURNAMENT]: MatchEditTournament,
  [TypeEventCodeEnum.TOURNAMENT_DOUBLE_ELEM]: MatchEditTournament,
};

export const MatchsView = () => {
  const { event } = useOutletContext<EventViewPageContext>();
  const { matchsRepository } = useContextDependency();
  const t = useTranslate();
  const staticFilters = {
    idEvent: event?.id,
  };
  const Component = ComponentByTypeEvent[event.typeEvent.code];

  if (!event) return null;

  return (
    <div className={'eventViewPageBloc eventViewPageMatchs'}>
      <Title
        title={t('event.eventViewPage.matchs.title')}
        level={1}
        threeQuarter
        bordered
      />
      {[EventStatusEnum.DRAFT, EventStatusEnum.PUBLISH].includes(event.status) && (
        <div className={'-infosWithText'}>
          <InfoOutlined />
          <span>{t('eventNotBegun')}</span>
        </div>
      )}
      {![EventStatusEnum.DRAFT, EventStatusEnum.PUBLISH].includes(event.status) && (
        <>{event && <Component event={event} retry={() => {}} asView />}</>
      )}
    </div>
  );
};
